'use client'
import { Icon } from '@/components'
import { EmptyContent } from '@/components/common/empty-content'
import { Box, Collapse, Skeleton, Stack, Typography } from '@mui/material'
import HTMLReactParser from 'html-react-parser/lib/index'
import { useState } from 'react'
import { TPolicyContent } from '../types'

export const Faqs = ({
  data: convertedData,
  isLoading,
}: {
  data: Omit<TPolicyContent, 'link_url'>[] | undefined
  isLoading?: boolean
}) => {
  const [active, setActive] = useState(0)

  if (!convertedData || convertedData.length === 0) {
    return <EmptyContent title="Chưa có nội dung" />
  }
  return (
    <Box>
      <Stack spacing={1}>
        {isLoading && <Loading />}
        {convertedData.map((item, index) => (
          <Stack
            onClick={() => {
              setActive(active === index ? -1 : index)
            }}
            sx={{
              p: '1rem 0',
              bgcolor: (theme) => (theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : '#fff'),
              borderRadius: '8px',
              cursor: 'pointer',
            }}
            spacing={'10px'}
            key={index}
          >
            <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'}>
              <Typography
                component="span"
                sx={{
                  fontSize: {
                    xs: '1rem',
                    md: '1.25rem',
                  },
                  fontWeight: 700,
                  cursor: 'pointer',
                  '&:hover': { color: 'primary.main' },
                  color: active === index ? 'primary.main' : 'inherit',
                }}
              >
                {item?.name}
              </Typography>
              <Icon.ArrowDown
                sx={{
                  transform: active === index ? 'rotate(180deg)' : 'rotate(0deg)',
                  transition: 'all 0.2s ease-in-out',
                  color: 'primary.main',
                }}
              />
            </Stack>
            <Collapse
              in={active === index}
              sx={{ marginTop: active == index ? '0.5rem' : '0px!important' }}
              timeout={300}
            >
              <Box
                sx={{
                  bgcolor: '#F4F5F8',
                  p: '1rem',
                  borderRadius: '8px',
                  fontSize: { xs: '0.75rem', md: '1rem' },
                  lineHeight: 1.6,
                }}
              >
                {HTMLReactParser(item?.short_description || '')}
              </Box>
            </Collapse>
          </Stack>
        ))}
      </Stack>
    </Box>
  )
}
const Loading = () => {
  return (
    <>
      {Array.from({ length: 2 }).map((_, index) => (
        <Box key={index} sx={{ width: '100%', flex: 1 }}>
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton width="60%" />
        </Box>
      ))}
    </>
  )
}
